/* unplugin-vue-components disabled */import script from "./examNo.vue?vue&type=script&lang=ts&setup=true"
export * from "./examNo.vue?vue&type=script&lang=ts&setup=true"

export default script